import type { CreativeForm } from '../form';

export enum CreativeTypeEnum {
  THIRD_PARTY = 'THIRD_PARTY',
  MEDIA_FILE = 'MEDIA_FILE',
  CLIENT_SUPPLY = 'CLIENT_SUPPLY',
  HEADER_BIDDER = 'HEADER_BIDDER',
  SMART_SERVER_BIDDING = 'SMART_SERVER_BIDDING',
  DEAL = 'DEAL',
  AMAZON_TAM = 'AMAZON_TAM',
  AMAZON_TAM_DEAL = 'AMAZON_TAM_DEAL',
  AMAZON_PMP = 'AMAZON_PMP',
  CNX_AD_EXCHANGE = 'CNX_AD_EXCHANGE',
}

export const CREATIVE_TYPE_OPTIONS: Array<{ label: string; value: CreativeTypeEnum }> = [
  { label: '3rd party tag', value: CreativeTypeEnum.THIRD_PARTY },
  { label: 'Media asset', value: CreativeTypeEnum.MEDIA_FILE },
  { label: 'JS API defined', value: CreativeTypeEnum.CLIENT_SUPPLY },
  { label: 'Prebid.js', value: CreativeTypeEnum.HEADER_BIDDER },
  { label: 'Smart server bidding', value: CreativeTypeEnum.SMART_SERVER_BIDDING },
  { label: 'Deal', value: CreativeTypeEnum.DEAL },
  { label: 'Amazon TAM/UAM', value: CreativeTypeEnum.AMAZON_TAM },
  { label: 'Amazon TAM - Deals', value: CreativeTypeEnum.AMAZON_TAM_DEAL },
  { label: 'Amazon private auction (PMP)', value: CreativeTypeEnum.AMAZON_PMP },
];

export const CREATIVE_TYPE_LABELS: Partial<Record<CreativeTypeEnum, string>> = {
  [CreativeTypeEnum.THIRD_PARTY]: '3rd party tag',
  [CreativeTypeEnum.MEDIA_FILE]: 'Media asset',
  [CreativeTypeEnum.CLIENT_SUPPLY]: 'JS API defined',
  [CreativeTypeEnum.HEADER_BIDDER]: 'Prebid.js',
  [CreativeTypeEnum.SMART_SERVER_BIDDING]: 'Smart server bidding',
  [CreativeTypeEnum.DEAL]: 'Deal',
  [CreativeTypeEnum.AMAZON_TAM]: 'Amazon TAM/UAM',
  [CreativeTypeEnum.AMAZON_TAM_DEAL]: 'Amazon TAM - Deals',
  [CreativeTypeEnum.AMAZON_PMP]: 'Amazon private auction (PMP)',
};

export enum TrackerTrigger {
  IMPRESSION = 'IMPRESSION',
  COMPLETE_25_PC = 'COMPLETE_25_PC',
  COMPLETE_50_PC = 'COMPLETE_50_PC',
  COMPLETE_75_PC = 'COMPLETE_75_PC',
  VIEW_COMPLETION = 'VIEW_COMPLETION',
  VIDEO_CLICK = 'VIDEO_CLICK',
  PAUSE = 'PAUSE',
  RESUME = 'RESUME',
  MUTE = 'MUTE',
  UNMUTE = 'UNMUTE',
}

export const TRACKER_TRIGGER_OPTIONS: Array<{ label: string; value: TrackerTrigger }> = [
  { label: 'Impression', value: TrackerTrigger.IMPRESSION },
  { label: 'Complete 25%', value: TrackerTrigger.COMPLETE_25_PC },
  { label: 'Complete 50%', value: TrackerTrigger.COMPLETE_50_PC },
  { label: 'Complete 75%', value: TrackerTrigger.COMPLETE_75_PC },
  { label: 'View completion', value: TrackerTrigger.VIEW_COMPLETION },
  { label: 'Video click', value: TrackerTrigger.VIDEO_CLICK },
  { label: 'Pause', value: TrackerTrigger.PAUSE },
  { label: 'Resume', value: TrackerTrigger.RESUME },
  { label: 'Mute', value: TrackerTrigger.MUTE },
  { label: 'Unmute', value: TrackerTrigger.UNMUTE },
];

export enum TrackerType {
  IMAGE = 'IMAGE',
  JAVASCRIPT = 'JAVASCRIPT',
}

export const TRACKER_TYPE_OPTIONS: Array<{ label: string; value: TrackerType }> = [
  { label: 'Image', value: TrackerType.IMAGE },
  { label: 'JavaScript', value: TrackerType.JAVASCRIPT },
];

export interface CreativeInventorySettings {
  placement: PlacementValue;
  startDelay: StartDelayValue;
}

export type Tracker = {
  name: string;
  trigger: TrackerTrigger | null;
  type: TrackerType | null;
  url: string;
};

export type PlacementValue = 'IN_STREAM' | 'IN_ARTICLE';

export const placementsOptions: { label: string; value: PlacementValue }[] = [
  { label: 'In-stream', value: 'IN_STREAM' },
  { label: 'In-article', value: 'IN_ARTICLE' },
];

export type StartDelayValue = 'AUTOMATIC_DETECTION' | 'PRE_ROLL' | 'MID_ROLL' | 'POST_ROLL';

export const startDelayOptions: { label: string; value: StartDelayValue }[] = [
  { label: 'Automatic detection', value: 'AUTOMATIC_DETECTION' },
  { label: 'Pre‑Roll', value: 'PRE_ROLL' },
  { label: 'Mid‑Roll', value: 'MID_ROLL' },
  { label: 'Post‑Roll', value: 'POST_ROLL' },
];

export interface AmazonTamPrices {
  code: string;
  price: number;
}

export interface CsvParseResult {
  success: boolean;
  data?: AmazonTamPrices[];
  error?: string;
}

export const CREATIVE_MOCK_DATA: CreativeForm = {
  id: '123abc',
  name: 'Test Creative',
  type: CreativeTypeEnum.THIRD_PARTY,
  url: 'https://example.com/creative',
  gdprvId: '123',
  shouldRenderVpaidInSecureIframe: true,
  inventorySettings: {
    placement: 'IN_STREAM',
    startDelay: 'AUTOMATIC_DETECTION',
  },
};
